import addQueryString from '@/utils/addQueryString'

export default {
  install(Vue) {
    Vue.prototype.$wxShare = (options) => {
      function jsBridge() {
        function callback() {
          console.log('WeixinJSBridge')
          WeixinJSBridge.on('menu:share:appmessage', () => {
            WeixinJSBridge.invoke('sendAppMessage', {
              appid: 'wxa817069bb040f860',
              img_url: options.img,
              img_width: '240',
              img_height: '240',
              link: addQueryString('CKTAG', 'mta_share.wechat_friend', options.href),
              desc: options.desc,
              title: options.title,
            })
          })
          WeixinJSBridge.on('menu:share:timeline', () => {
            WeixinJSBridge.invoke('shareTimeline', {
              img_url: options.img,
              img_width: '240',
              img_height: '240',
              link: addQueryString('CKTAG', 'mta_share.wechat_moments', options.href),
              title: options.title,
            })
          })
        }
        if (window.WeixinJSBridge && typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
          callback()
        } else if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', callback, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', callback)
          document.attachEvent('onWeixinJSBridgeReady', callback)
        }
      }
      if (wx && wx.updateAppMessageShareData) {
        console.log('jssdk')
        wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: options.title,
            desc: options.desc,
            link: addQueryString('CKTAG', 'mta_share.wechat_friend', options.href),
            imgUrl: options.img,
            fail: () => {
              jsBridge()
            },
          })
          wx.updateTimelineShareData({
            title: options.title,
            link: addQueryString('CKTAG', 'mta_share.wechat_friend', options.href),
            imgUrl: options.img,
          })
        })
      } else {
        jsBridge()
      }
    }
  },
}
